import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import {
  Input,
  Select,
  Row,
  Col,
  Button,
  DatePicker,
  Checkbox,
  Modal
} from 'hljd'
import ImgGallery from '@common/ImgGallery'
import { observer } from 'mobx-react'
import store from './store'
const CheckboxGroup = Checkbox.Group
const plainOptions = ['午市', '晚市']
const Item = Form.Item
const Option = Select.Option
const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 15 }
}

@observer
export default class extends Component {
  render() {
    let hall = store.hallData.map(v => {
      let _obj = (
        <Option key={v.id} value={v.id}>
          {v.name}
        </Option>
      )
      return _obj
    })
    return (
      <Modal
        visible={store.visible}
        footer={null}
        onCancel={store.handleCancel}
      >
        <div>
          <Form>
            <Item {...layout} />
            <Item {...layout} required label="婚期">
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                onChange={store.setDate}
              />
            </Item>
            <Item {...layout} required label="婚宴酒店">
              {store.hotelName}
            </Item>
            <Item {...layout} required label="婚宴场地">
              <Select onChange={store.setHall} placeholder="请选择">
                {hall}
              </Select>
            </Item>
            <Item {...layout} required label="市别">
              <CheckboxGroup options={plainOptions} onChange={store.setCol} />
            </Item>
            <Row>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  required
                  label="桌数"
                >
                  <Input onChange={store.setTable} style={{ width: 80 }} />
                  <i style={{ marginLeft: 10 }}>桌</i>
                </Item>
              </Col>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  required
                  label="备桌"
                >
                  <Input
                    onChange={store.setTable_backUp}
                    style={{ width: 80 }}
                  />
                  <i style={{ marginLeft: 10 }}>桌</i>
                </Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  required
                  label="餐标"
                >
                  <Input onChange={store.setTablePrice} style={{ width: 80 }} />
                  <i style={{ marginLeft: 10 }}>元</i>
                </Item>
              </Col>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  required
                  label="其他费用"
                >
                  <Input
                    onChange={store.setHPrice_other}
                    style={{ width: 80 }}
                  />
                  <i style={{ marginLeft: 10 }}>元</i>
                </Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  required
                  label="婚宴总价"
                >
                  <Input onChange={store.setHPrice} style={{ width: 80 }} />
                  <i style={{ marginLeft: 10 }}>元</i>
                </Item>
              </Col>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  required
                  label="已收定金"
                >
                  <Input onChange={store.setHdeposit} style={{ width: 80 }} />
                  <i style={{ marginLeft: 10 }}>元</i>
                </Item>
              </Col>
            </Row>
            <Item
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 18 }}
              label="凭证上传"
            >
              <em>上传有效凭证有助于通过审核，最多上传5张</em>
              <ImgGallery
                max={5}
                onRemove={store.removeImg}
                multiple={true}
                onOk={store.upImg}
                imgList={store.imgs}
              />
            </Item>
          </Form>
          <div style={{ marginBottom: 30, textAlign: 'center' }}>
            <Button
              onClick={store.sendForm}
              style={{ marginRight: 15, width: 120 }}
              type="primary"
            >
              提交审核
            </Button>
            <Button onClick={store.handleCancel} style={{ width: 120 }}>
              取消
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}
